import React from 'react';
import Section from "./Section.js";
import Language from "../modules/Language";
import Actions from "../modules/actions";
import { connect } from "react-redux";
import { Typography } from '@material-ui/core';
import MyButton from "./MyButton";
import Link from "./Link";
import SubSection from "./SubSection";

const mapStateToProps = (state, ownProps) => {
  return ({
    isEnglish: Language.isEnglish(state.lang),
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeLang: newLang => dispatch(Actions.changeLanguage(newLang)),
  expandManage: () => dispatch(Actions.expandSection("Manage")),
});

const Welcome = props => {
  const Lang = props.lang.Welcome;
  return (
    <Section id="Welcome" header={Lang.header} headerBody={
      // put this in a row and then 2 columns
      props.isEnglish
        ? <MyButton variant="contained" onClick={() => props.changeLang(Language.FRENCH)}>Français</MyButton>
        : <MyButton variant="contained" onClick={() => props.changeLang(Language.ENGLISH)}>English</MyButton>
    }>
      <Typography> {Lang.p1} </Typography>
      <Typography> {Lang.p2} </Typography>
      <Typography> {Lang.p3} </Typography>
      <SubSection>
        <Typography> {Lang.p4} </Typography>
        <Link url="https://birdsafe.ca/birdsafe-consulting-service/" text={Lang.vist_birdsafe}/>
        <Typography> {Lang.p5} </Typography>
        <Link url="https://birdsafe.ca/acknowledgements/" text={Lang.acknowledgements}/>
      </SubSection>
      <MyButton variant="contained" onClick={props.expandManage}>{Lang.begin}</MyButton>
    </Section>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Welcome);



// WEBPACK FOOTER //
// ./src/pages/Welcome.js